import { render, staticRenderFns } from "./possibilityCardVariant.vue?vue&type=template&id=8e458e4c&scoped=true&"
import script from "./possibilityCardVariant.vue?vue&type=script&lang=js&"
export * from "./possibilityCardVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e458e4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VImg,VSheet})
